// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2B06x","tab":"ProcedureTabs_tab__2suRq"};